module.exports = __webpack_public_path__ + "images/file_icons_v2/tex-754fad3e3396e18ce9ec3323b154f6b5.svg";